import React, { useState } from 'react';
import CamposEventoEdicao from './CamposEventoEdicao';
import { eventoVazio, eventoCompleto, payloadEvento, rotuloTipoEdicao, tiposPermitidos, descreverAlteracao, TIPOS_EDICAO } from './edicaoValor';

// Itens de contrato ATIVO com valor unitário ou quantidade contratada alterados
// (09/out/2026): o backend recusa o save com `exige_evento` e a lista por contrato;
// aqui o usuário informa o evento e o save é reenviado com ele.
const brl = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const focoCls = 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-vox-blue-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-gray-800';

const ModalEventoEdicao = ({ contratos = [], onConfirmar, onCancelar, enviando = false }) => {
    const [evento, setEvento] = useState(eventoVazio());
    // Um contrato só: oferece os tipos coerentes com o sinal; vários: tipo automático por contrato.
    const unico = contratos.length === 1 ? contratos[0] : null;
    const permitidos = unico ? tiposPermitidos(unico.valor_antes, unico.valor_depois) : [];
    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center p-4'>
            <div className='fixed inset-0 bg-black/50' />
            <div role='dialog' aria-modal='true' aria-labelledby='evento-edicao-titulo'
                className='relative flex max-h-[90vh] w-full max-w-2xl flex-col rounded-xl bg-white shadow-2xl dark:bg-gray-800'>
                <header className='border-b border-gray-200 px-6 py-4 dark:border-gray-700'>
                    <h2 id='evento-edicao-titulo' className='text-xl font-bold text-vox-blue-900 dark:text-white'>Alteração de valor vira evento</h2>
                    <p className='mt-0.5 text-sm text-gray-500 dark:text-gray-400'>Contrato ativo: preço unitário e quantidade contratada só mudam por evento (aditivo, supressão ou reajuste).</p>
                </header>
                <div className='flex-1 min-h-0 space-y-4 overflow-auto px-6 py-5'>
                    {contratos.map((c) => (
                        <section key={c.id_contrato} aria-label={`Contrato ${c.nome || c.id_contrato}`}
                            className='rounded-lg border border-gray-200 p-3 text-sm dark:border-gray-700'>
                            <p className='font-semibold text-gray-900 dark:text-white'>{c.nome || `Contrato ${c.id_contrato}`}</p>
                            <ul className='mt-1 list-disc space-y-0.5 pl-5 text-gray-700 dark:text-gray-300'>
                                {(c.alteracoes || []).map((a, k) => <li key={k} className='tabular-nums'>{descreverAlteracao(a)}</li>)}
                            </ul>
                            <p className='mt-1 text-gray-600 dark:text-gray-400 tabular-nums'>
                                Mensal contratado: {brl(c.valor_antes)} → {brl(c.valor_depois)} · sugerido: <b>{rotuloTipoEdicao(c.tipo_sugerido)}</b>
                            </p>
                        </section>
                    ))}
                    <CamposEventoEdicao idPrefixo='itens-edicao' evento={evento} onChange={setEvento}
                        sugerido={unico ? unico.tipo_sugerido : null}
                        permitidos={unico ? permitidos : TIPOS_EDICAO.filter((t) => t.valor === 'reajuste')}
                        aviso='O evento entra na timeline de cada contrato, com proporcional a partir da data de vigência. A quantidade implantada não muda.' />
                </div>
                <footer className='flex flex-col-reverse gap-2 border-t border-gray-200 px-6 py-3 dark:border-gray-700 sm:flex-row sm:justify-end'>
                    <button type='button' onClick={onCancelar} disabled={enviando}
                        className={`rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:text-gray-200 dark:hover:bg-gray-700 ${focoCls}`}>
                        Voltar
                    </button>
                    <button type='button' onClick={() => onConfirmar(payloadEvento(evento))} disabled={enviando || !eventoCompleto(evento)}
                        className={`rounded-lg bg-vox-blue-900 px-4 py-2 text-sm font-semibold text-white hover:bg-vox-blue-800 disabled:cursor-not-allowed disabled:opacity-50 dark:bg-vox-blue-600 dark:hover:bg-vox-blue-500 ${focoCls}`}>
                        {enviando ? 'Salvando…' : 'Lançar evento e salvar'}
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default ModalEventoEdicao;
